(() => {
  'use strict';

  if (window.BlusafePhotoHelp) {
    window.BlusafePhotoHelp.init(document);
    return;
  }

  const initModule = (module) => {
    if (!(module instanceof HTMLElement) || module.dataset.helpInitialized === 'true') return;
    module.dataset.helpInitialized = 'true';

    const dialog = module.querySelector('[data-help-dialog]');
    const copyStatus = module.querySelector('[data-help-copy-status]');
    let lastInvoker = null;

    const resolveVariant = () => {
      const form = document.querySelector('form[action*="/cart/add"]');
      const id = form?.querySelector('[name="id"]')?.value || module.dataset.variantId || '';
      return {
        id,
        title: module.dataset.variantTitle || '',
        sku: module.dataset.sku || ''
      };
    };

    const buildMessage = () => {
      const variant = resolveVariant();
      const url = new URL(module.dataset.productUrl || window.location.href, window.location.origin);
      url.search = '';
      url.hash = '';
      if (variant.id) url.searchParams.set('variant', variant.id);
      const variantTitle = variant.title === 'Default Title' ? 'Default' : (variant.title || 'Not selected');
      return [
        'Hi Blusafe U.S. — I need help checking this will fit before I order.', '',
        `Product: ${module.dataset.productTitle}`,
        `Variant/SKU: ${variantTitle} / ${variant.sku || 'No SKU shown'}`,
        `Page: ${url.toString()}`, '',
        'I will attach photos of my existing handle or lock, plus measurements of my door.'
      ].join('\n');
    };

    const openDialog = (invoker) => {
      lastInvoker = invoker;
      if (typeof dialog?.showModal === 'function') dialog.showModal();
      else if (dialog) {
        dialog.setAttribute('open', '');
        dialog.setAttribute('data-fallback-open', '');
        dialog.querySelector('[data-help-close]')?.focus();
      }
    };

    const closeDialog = () => {
      if (typeof dialog?.close === 'function' && dialog.open) dialog.close();
      else if (dialog) {
        dialog.removeAttribute('open');
        dialog.removeAttribute('data-fallback-open');
        lastInvoker?.focus();
      }
    };

    module.querySelectorAll('[data-help-open]').forEach((button) => button.addEventListener('click', () => openDialog(button)));
    module.querySelectorAll('[data-help-close]').forEach((button) => button.addEventListener('click', closeDialog));
    dialog?.addEventListener('close', () => lastInvoker?.focus());
    dialog?.addEventListener('click', (event) => { if (event.target === dialog) closeDialog(); });
    dialog?.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      closeDialog();
    });

    module.querySelectorAll('[data-help-whatsapp]').forEach((link) => link.addEventListener('click', () => {
      const phone = (module.dataset.whatsappNumber || '').replace(/\D/g, '');
      link.href = `https://wa.me/${phone}?text=${encodeURIComponent(buildMessage())}`;
    }));

    module.querySelectorAll('[data-help-email]').forEach((link) => link.addEventListener('click', () => {
      const email = module.dataset.email || '';
      const subject = module.dataset.emailSubject || 'Will it fit?';
      link.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(buildMessage())}`;
    }));

    module.querySelector('[data-help-copy]')?.addEventListener('click', async () => {
      const message = buildMessage();
      let copied = false;
      try {
        await navigator.clipboard.writeText(message);
        copied = true;
      } catch (_) {
        const text = document.createElement('textarea');
        text.value = message;
        text.setAttribute('readonly', '');
        text.style.position = 'fixed';
        text.style.opacity = '0';
        document.body.appendChild(text);
        text.select();
        try { copied = document.execCommand('copy'); } catch (_) { copied = false; }
        text.remove();
      }
      if (copyStatus) {
        copyStatus.textContent = copied
          ? 'Message copied. Paste it into an email or WhatsApp.'
          : 'Copy failed. Please use the email or WhatsApp buttons instead.';
      }
    });
  };

  const init = (root = document) => {
    if (root.matches?.('[data-bs-photo-help]')) initModule(root);
    root.querySelectorAll?.('[data-bs-photo-help]').forEach(initModule);
  };

  window.BlusafePhotoHelp = { init };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
